import { useContext, useEffect, useState } from "react";
import { getAnuncios } from "../services/home.services";
import { TenantsContext } from "../../../context/tenants.context";

export interface IAnuncios {
  idNoticia: number;
  idAnuncio: number;
  idAnuncioTipo: number;
  anuncianteNombre: string;
  nombre: string;
  url_imagen: string;
  urlImagen: string;
  urlImagenWide: string;
  detalleTexto: string | null;
  detalleURLImagen: string | null;
  detalleLink: string | null;
  orden: number;
  data: any;
  premium: boolean;
}

export const useAnuncios = (idLocal: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [anuncios, setAnuncios] = useState<any[]>();
  const {tenant} = useContext(TenantsContext);

  const fetchData = async (idLocal: number) => {
    try {
      setLoading(true);
      await getAnuncios(idLocal, tenant).then((res) =>
        setAnuncios(res.data.anuncios)
      );
    } catch {
      console.log();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(idLocal);
  }, [idLocal]);

  return { anuncios, fetchData, loading };
};
